import { LoadingState } from '@nolens/ui';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useMe } from '../lib/queries';
import { useSession } from '../lib/session';

export const MFA_PATH = '/verificacao';

export function RequireSession() {
  const { session, loading } = useSession();
  const location = useLocation();
  const me = useMe(!!session);
  if (loading) return <LoadingState />;
  if (!session) return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  // Equipa sem segundo fator nesta sessão: primeiro a verificação (a API e o RLS exigem-na).
  if (me.data?.mfaRequired && location.pathname !== MFA_PATH) return <Navigate to={MFA_PATH} replace />;
  return <Outlet />;
}
